<script lang="ts" setup>
import { useTranslate } from '@nzyme/vue-i18n/useTranslate.js';
import HealedLogo from '@sigma/assets/healed-logo-word-mark-w.svg?component';
import { useLocale } from '@sigma/client/i18n/useLocale.js';
import {
  AccessibilityStatementRoute,
  LegalNoticeRoute,
  PrivacyPolicyRoute,
  TermsOfServiceRoute,
} from '@sigma/patient-common/routes.js';
import LanguagePicker from '@sigma/ui/LanguagePicker.vue';

import * as l from './MainFooter.loc.js';

const t = useTranslate();
const locale = useLocale();
</script>

<template>
  <footer :class="css.footer">
    <div :class="css.footerTop">
      <a
        href="/"
        :class="css.footerLogo"
        :aria-label="t(l.healedHomepage)"
      >
        <HealedLogo :class="css.footerLogoSvg" />
      </a>

      <!-- <nav :class="css.footerTopNav">
        <a
          href="/"
          :class="css.footerTopLink"
        >
          {{ t(l.footerForPatients) }}
        </a>
        <a
          href="/physicians.html"
          :class="css.footerTopLink"
        >
          {{ t(l.footerForPhysicians) }}
        </a>
      </nav> -->

      <LanguagePicker :class="css.languagePicker" />
    </div>

    <hr :class="css.divider" />

    <div :class="css.footerBottom">
      <div :class="css.footerBottomText">{{ t(l.footerEmergencyNotice) }}</div>
      <nav :class="css.footerBottomNav">
        <RouterLink
          :to="PrivacyPolicyRoute({ locale })"
          :class="css.footerBottomLink"
        >
          {{ t(l.footerPrivacyPolicy) }}
        </RouterLink>
        <RouterLink
          :to="TermsOfServiceRoute({ locale })"
          :class="css.footerBottomLink"
        >
          {{ t(l.footerTermsOfService) }}
        </RouterLink>
        <RouterLink
          :to="AccessibilityStatementRoute({ locale })"
          :class="css.footerBottomLink"
        >
          {{ t(l.footerAccessibilityStatement) }}
        </RouterLink>
        <RouterLink
          :to="LegalNoticeRoute({ locale })"
          :class="css.footerBottomLink"
        >
          {{ t(l.footerLegalNotice) }}
        </RouterLink>
      </nav>
    </div>
  </footer>
</template>

<style lang="scss" module="css">
.footer {
  padding: var(--space-small) var(--padding-global) 0 var(--padding-global);
  background: $color-patient-950;
  color: $color-white;

  @media screen and (min-width: 1280px) {
    padding: var(--space-medium) var(--space-medium) 0 var(--space-medium);
  }
}

.footerTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 var(--space-small) 0;
  align-items: start;
  gap: var(--space-large);
}

.footerBottom {
  display: flex;
  justify-content: space-between;
  padding: var(--space-small) 0;
  gap: var(--space-small);
  flex-direction: column-reverse;

  @media screen and (min-width: 768px) {
    padding: var(--space-xsmall) 0;
    gap: var(--space-xsmall);
  }

  @media screen and (min-width: 1280px) {
    flex-direction: row;
  }
}

.footerLogo {
  display: block;
}

.footerLogoSvg {
  display: block;
  width: 100px;
  height: auto;
}

.languagePicker {
  padding: $spacing-04 $spacing-16;
}

.footerTopNav {
  display: flex;
  flex-direction: column;
  gap: 1em;

  @include media-min-md {
    flex-direction: row;
  }
}

.footerTopLink {
  color: $color-white;
  text-decoration: none;
  transition: color $transition-duration $transition-ease-out-quad;

  &:hover,
  &:focus {
    color: $opacity-white-60;
  }
}

// .footerBottomText - No specific styles needed, inherits from parent

.footerBottomNav {
  display: flex;
  flex-direction: column;
  gap: 1em;

  @media screen and (min-width: 768px) {
    flex-direction: row;
  }
}

.footerBottomLink {
  color: $opacity-white-50;
  text-decoration: none;
  transition: color $transition-duration $transition-ease-out-quad;

  &:hover,
  &:focus {
    color: $color-white;
  }
}

.divider {
  border: none;
  height: 1px;
  padding: 0;
  margin: 0;
  background: linear-gradient(90deg, $color-patient-200, $color-doctor-200);
}
</style>
